import {
  adminGymDetailSchema,
  adminGymMemberLimitSchema,
  adminGymOwnerInviteSchema,
  type AdminGymDetail,
  type AdminGymMemberLimit,
  type AdminGymOwnerInvite,
} from '@steado/admin-contract/gyms';
import { queryOptions } from '@tanstack/react-query';

import type { ApiClient } from '@/lib/api/client';

/** One gym. The Users screen reads it too, for the name of the gym it is filtered to. */
export function gymDetailQueryOptions(api: ApiClient, gymId: string) {
  return queryOptions({
    queryKey: ['admin', 'gym', gymId],
    queryFn: (): Promise<AdminGymDetail> =>
      api.request({ path: `/admin/gyms/${gymId}`, schema: adminGymDetailSchema }),
  });
}

/** Emails the owner a fresh invite; the older link stops working. */
export function resendOwnerInvite(api: ApiClient, gymId: string): Promise<AdminGymOwnerInvite> {
  return api.request({
    path: `/admin/gyms/${gymId}/owner-invite`,
    method: 'POST',
    schema: adminGymOwnerInviteSchema,
  });
}

/** Sets how many members the gym may have; 409 MEMBER_LIMIT_BELOW_COUNT below the members it has. */
export function updateMemberLimit(
  api: ApiClient,
  gymId: string,
  memberLimit: number,
): Promise<AdminGymMemberLimit> {
  return api.request({
    path: `/admin/gyms/${gymId}/member-limit`,
    method: 'PUT',
    body: { memberLimit },
    schema: adminGymMemberLimitSchema,
  });
}
